// extracted by mini-css-extract-plugin
module.exports = {"root":"IsCountingBlock_root__r_m1N"};